import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

export interface SaveWarningDialogData {
    allowPartialSave: boolean;
    hasConfirm: boolean;
    hasCancel: boolean;
    hasConfirmWithoutSave: boolean;
    valid: boolean;
    disableSave?: boolean;
}

@Component({
    selector: 'r1-compass-lib-generic-confirmation-dialog',
    imports: [MatButtonModule, MatDialogModule],
    template: `
        <h1 mat-dialog-title>Are you sure?</h1>

        <div mat-dialog-content>
            <p>Your changes will be lost if you don't save them.</p>
        </div>

        <div mat-dialog-actions class="config-change-actions">
            @if (data.hasConfirm) {
                <button
                    mat-raised-button
                    color="primary"
                    (click)="onClose(true, 'confirm')"
                    type="button"
                    [disabled]="data.disableSave ?? (!data.valid && !data.allowPartialSave)">
                    Save
                </button>
            }
            @if (data.hasConfirmWithoutSave) {
                <button mat-raised-button color="" (click)="onClose(false, 'confirmWithoutSave')" type="button">
                    Don't Save
                </button>
            }
            @if (data.hasCancel) {
                <button mat-stroked-button color="black" (click)="onClose(false, 'cancel')" type="button">
                    Cancel
                </button>
            }
        </div>
    `,
    styles: `
        .config-change-actions {
            justify-content: flex-end;
            border-top: solid 1px var(--r1-light-gray);
        }
    `,
})
export class SaveWarningDialogComponent {
    dialogRef = inject<MatDialogRef<SaveWarningDialogComponent>>(MatDialogRef);
    data = inject<SaveWarningDialogData>(MAT_DIALOG_DATA);

    public onClose(confirm: boolean, type: 'confirm' | 'cancel' | 'confirmWithoutSave'): void {
        this.dialogRef.close({ confirm: confirm, type: type });
    }
}
